/**
 * Port of the old global mixin's `allows()` method
 * (apps/admin/src/mixins/global.js) — same passthrough to UserService.allows,
 * same semantics for a single permission string or an array of permissions.
 */
import { UserService } from 'app-core'

export function usePermissions() {
    /**
     * Check if the current user has one permission or
     * multiple specified permissions.
     */
    function allows(permissions: string | string[]): boolean {
        return UserService.allows(permissions)
    }

    return { allows }
}
